import { constants } from "@newsela/angelou";

const darkBlue = constants.colors.ui.core[700];

export const selectedStateIndicatorCss = {
  background: darkBlue,
  borderRadius: "4px",
  height: "calc(100% - 8px)",
  left: "4px",
  position: "absolute",
  top: "4px",
  width: "4px",
};
